import React, {memo} from "react";
import styled from "styled-components";

import bombFrame1 from './../../assets/bomb/bombAnimation/1.png';
import bombFrame2 from './../../assets/bomb/bombAnimation/2.png';
import bombFrame3 from './../../assets/bomb/bombAnimation/3.png';
import bombFrame4 from './../../assets/bomb/bombAnimation/4.png';
import bombFrame5 from './../../assets/bomb/bombAnimation/5.png';
import bombFrame6 from './../../assets/bomb/bombAnimation/6.png';
import bombFrame7 from './../../assets/bomb/bombAnimation/7.png';
import bombFrame8 from './../../assets/bomb/bombAnimation/8.png';
import bombFrame9 from './../../assets/bomb/bombAnimation/9.png';

import boomFrame1 from './../../assets/bomb/cadr_1.png';
import boomFrame2 from './../../assets/bomb/cadr_2.png';
import boomFrame3 from './../../assets/bomb/cadr_3.png';
import boomFrame4 from './../../assets/bomb/cadr_4.png';
import boomFrame5 from './../../assets/bomb/cadr_5.png';
import boomFrame6 from './../../assets/bomb/cadr_6.png';
import boomFrame7 from './../../assets/bomb/cadr_7.png';
import boomFrame8 from './../../assets/bomb/cadr_8.png';
import boomFrame9 from './../../assets/bomb/cadr_9.png';
import boomFrame10 from './../../assets/bomb/cadr_10.png';
import boomFrame11 from './../../assets/bomb/cadr_11.png';
import boomFrame12 from './../../assets/bomb/cadr_12.png';
import boomFrame13 from './../../assets/bomb/cadr_13.png';
import boomFrame14 from './../../assets/bomb/cadr_14.png';
import boomFrame15 from './../../assets/bomb/cadr_15.png';
import boomFrame16 from './../../assets/bomb/cadr_16.png';
import boomFrame17 from './../../assets/bomb/cadr_17.png';
import boomFrame18 from './../../assets/bomb/cadr_18.png';


const pictures = [
    boomFrame1,
    boomFrame2,
    boomFrame3,
    boomFrame4,
    boomFrame5,
    boomFrame6,
    boomFrame7,
    boomFrame8,
    boomFrame9,
    boomFrame10,
    boomFrame11,
    boomFrame12,
    boomFrame13,
    boomFrame14,
    boomFrame15,
    boomFrame16,
    boomFrame17,
    boomFrame18,
    bombFrame1, bombFrame2, bombFrame3, bombFrame4, bombFrame5, bombFrame6, bombFrame7, bombFrame8, bombFrame9
];

const Root = styled.div`
    position: fixed;
    opacity: 0;
    pointer-events: none;
`;

export const UploadBombSprites = memo(() => {
    return (
        <Root>
            {pictures.map(src => (
                <img key={src} style={{opacity: 0, position: 'fixed', pointerEvents: 'none'}} src={src} alt=""/>
            ))}
        </Root>
    )
})